import { HttpClient, HttpResponseBase } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError as _observableThrow } from 'rxjs'
import {
    catchError as _observableCatch,
    mergeMap as _observableMergeMap,
} from 'rxjs/operators'

import { BaseService } from '../shared/base.service'
import { MainService } from '../shared/main.service'
import { API, HANDSHAKE } from '../utils/constants'
import { OptionsType } from '../utils/handshake.model'
import { ConfigService } from './config.service'

@Injectable({
    providedIn: 'root',
})
export class CheckService {
    isHandShakeFlg: boolean;
    API_URL: string;

    constructor(
        private http: HttpClient,
        private mainService: MainService,
        private baseService: BaseService,
        private configSevice: ConfigService
    ) {
        this.isHandShakeFlg = this.configSevice.get(HANDSHAKE);
        this.API_URL = this.configSevice.get(API);
    }

    // getFormByQRCode
    getFormByQRCode(code: string): Observable<any> {
        let url_ = this.API_URL + 'Check/GetFormByQRCode';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { code: code },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    //Get form from EPortal
    getFormEPByQRCode(code: string): Observable<any> {
        let url_ = this.API_URL + 'Check/GetFormEPByQRCode';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { code: code },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // check
    check(code: string): Observable<any> {
        let url_ = this.API_URL + 'Check/Check';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { code: code },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // getDepositAccountDetail
    getDepositAccountDetail(obj: any): Observable<any> {
        let url_ = this.API_URL + 'Check/GetDepositAccountDetail';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            obj,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // getMDRest
    getMDRest(model: any): Observable<any> {
        let url_ = this.API_URL + 'Check/GetMDRest';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // loginDepositContract
    loginDepositContract(password: string): Observable<any> {
        let url_ = this.API_URL + 'Check/LoginDepositContract';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { password: password },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // getProductGroups
    getProductGroups(productGroupId: number): Observable<any> {
        var apiProductGroup = "Check/GetProductGroupListByIdInput?IdInput=" + productGroupId;
        if (productGroupId == null || productGroupId == undefined)
            apiProductGroup = "Booking/GetAllProductGroups";

        return this.http.post<Observable<any>>(this.API_URL + apiProductGroup, {});
    }

    getDepositQREnquiry(code: string): Observable<any> {
        let url_ = this.API_URL + 'Check/GetDepositQREnquiry';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { code: code },
            null,
            func,
            this.isHandShakeFlg,
        )
    }
}